export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  const normalizedUrl = url.endsWith('/') ? url : `${url}/`
  const normalizedCurrent = current.endsWith('/') ? current : `${current}/`

  if (normalizedCurrent.startsWith(normalizedUrl)) {
    return true
  }

  return false
}
